import { ActStatus } from "~/entity/Ivideon/model/schema";

export const LICENSES = ["licenseCode", "tariffName", "dateAct"];

export const ACT_STATUSES: ActStatus[] = [
  "created",
  "confirmed",
  "rejected",
  "closed",
];

export const DEFAULT_ACT_STATUSES: ActStatus[] = ["created", "confirmed"];

export const TYPE_OPEN_MODAL = {
  code: "code",
  deacceptAct: "deacceptAct",
  acceptAct: "acceptAct",
} as const;

export type TypeOpenModal =
  (typeof TYPE_OPEN_MODAL)[keyof typeof TYPE_OPEN_MODAL];

// Временно скрыт переключатель "Наличие актов/счетов" (PASDILER-1729)
export const SHOW_CHECK_STATUS_TOGGLE = false;

export const MODAL_TITLE: Record<string, string> = {
  [TYPE_OPEN_MODAL.code]: "Список лицензий",
  [TYPE_OPEN_MODAL.deacceptAct]: "Вы действительно хотите отклонить акт?",
  [TYPE_OPEN_MODAL.acceptAct]: "Вы действительно хотите отправить коды?",
};
